import { useAbility } from '@cast/shared-ability-data-access';

export const useIsConfirmationRequiredOnToggleOptimization = () => {
  const isConfirmationRequired = useAbility().can(
    'view',
    'ClusterWorkloadRequireWorkloadToggleConfirmation'
  );

  return {
    isConfirmationRequired,
  };
};
